import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { EditOperation } from '../../common/core/editOperation.js';
import { Range } from '../../common/core/range.js';
export var FormattingEdit = /*#__PURE__*/function () {
  function FormattingEdit() {
    _classCallCheck(this, FormattingEdit);
  }

  _createClass(FormattingEdit, null, [{
    key: "_handleEolEdits",
    value: function _handleEolEdits(editor, edits) {
      var newEol = undefined;
      var singleEdits = [];

      var _iterator = _createForOfIteratorHelper(edits),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var edit = _step.value;

          if (typeof edit.eol === 'number') {
            newEol = edit.eol;
          }

          if (edit.range && typeof edit.text === 'string') {
            singleEdits.push(edit);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (typeof newEol === 'number') {
        if (editor.hasModel()) {
          editor.getModel().pushEOL(newEol);
        }
      }

      return singleEdits;
    }
  }, {
    key: "_isFullModelReplaceEdit",
    value: function _isFullModelReplaceEdit(editor, edit) {
      if (!editor.hasModel()) {
        return false;
      }

      var model = editor.getModel();
      var editRange = model.validateRange(edit.range);
      var fullModelRange = model.getFullModelRange();
      return fullModelRange.equalsRange(editRange);
    }
  }, {
    key: "execute",
    value: function execute(editor, _edits, addUndoStops) {
      if (addUndoStops) {
        editor.pushUndoStop();
      }

      var edits = FormattingEdit._handleEolEdits(editor, _edits);

      if (edits.length === 1 && FormattingEdit._isFullModelReplaceEdit(editor, edits[0])) {
        // We use replace semantics and hope that markers stay put...
        editor.executeEdits('formatEditsCommand', edits.map(function (edit) {
          return EditOperation.replace(Range.lift(edit.range), edit.text);
        }));
      } else {
        editor.executeEdits('formatEditsCommand', edits.map(function (edit) {
          return EditOperation.replaceMove(Range.lift(edit.range), edit.text);
        }));
      }

      if (addUndoStops) {
        editor.pushUndoStop();
      }
    }
  }]);

  return FormattingEdit;
}();